import type { InterventionTemplateLabelProps } from "./intervention-template-label.type";

import { Space } from "antd";
import { useTranslation } from "react-i18next";

import { FlexContainerJsx } from "@/modules/flex-container";
import { getModelLink } from "@/modules/model";
import { StateTag } from "@/modules/state-tag";

export const InterventionTemplateLabel = ({
  template,
}: InterventionTemplateLabelProps) => {
  const { t } = useTranslation();

  return (
    <FlexContainerJsx
      value={
        <Space>
          <StateTag value={template.state} type="interventionTemplate" />
          {`${template.name} v${template.version}`}
        </Space>
      }
      link={getModelLink("interventiontemplate", template.id)}
      label={t("intervention:form.template.label")}
      noWrapper
    />
  );
};
